<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>

    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex flex-column p-4">
        <div class="d-flex justify-content-between">
          <div class="text-right m-4">
            <h5 style="font-size: 1vw !important"> شناسایی مسئله/ {{$route.params.title}} </h5>
          </div>
          <div class="d-flex">
            <a :href="`${this.download_url}/Problem_identification/all/word/by/id/${id_route}`" style="margin-top: 1.3vw;"
               class="btn btn-primary btn-submit-1">خروجی Word</a>
            <a :href="`${this.download_url}/Problem_identification/all/pdf/by/id/${id_route}`"
               style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
              PDF</a>
            <a    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; " class="btn btn-primary btn-submit-1 "
                  :style="!status_show ? 'background-color: red; border-color: red' : 'background-color: green; border-color: green'"
                  @click="acceptComplete"
            >
              <div v-if="!status_loading">

                <span v-if="!status_show">  تایید وضعیت</span>
                <span v-else>عدم تایید</span>
              </div>
              <div v-else>
                <div class="loader-line"></div>

              </div>
            </a>
          </div>

        </div>
        </div>



      <div class="p-4 table-responsive">

        <center v-show="!allItems.length">
          مسئله وجود ندارد
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table class="table table-striped  " v-show="allItems.length">
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>
            <th rowspan="2"><strong>
              نشانه مسئله
            </strong></th>

            <th rowspan="2"><strong>عنوان مسئله</strong></th>
            <th rowspan="2"><strong> سطح مسئله </strong></th>
            <th colspan="6"><strong>نماگر وضعیت مسئله</strong></th>
            <th rowspan="2"><strong>ماموریت</strong></th>
            <th colspan="3"><strong> خدمت متناظر</strong></th>
          </tr>
          <tr>
            <th>عنوان نماگر</th>
            <th>نوع نماگر</th>
            <th>فرمول</th>
            <th>مقدار
              کنونی
            </th>
            <th>مقدار مطلوب</th>
            <th>مرجع اخذ داده</th>
            <th>کلان خدمت</th>
            <th>زیرخدمت</th>
            <th>دستگاه‌های تابعه همکار</th>
          </tr>
          <tr v-for="(item, index) in allItems">
            <td>{{ index + 1 }}</td>
            <td>{{ item.sign }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.title_photographer }}</td>
            <td>{{ item.type_photographer }}</td>
            <td>{{ item.formula }}</td>
            <td>{{ item.value_now }}</td>
            <td>{{ item.value_optimal }}</td>
            <td>{{ item.collection_reference }}</td>
            <td>{{ item.determining_missions && item.determining_missions.axis }}</td>
            <td>{{ item.processes && item.processes.title }}</td>
            <td>{{ item.sub_processes && item.sub_processes.title }}</td>
            <td>{{ item.collaborative_devices }}</td>


          </tr>


          </tbody>
        </table>
      </div>


    </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import vSelect from "vue-select";
import {useToast} from "vue-toastification";
import router from "@/router";

const toast = useToast();

export default {
  components: {
    Sidebar,
    splash,
    vSelect

  },
  data() {
    return {
      allItems: [],
      Process: [],
      allItemsDetermining_Mission: [],
      Determining_Mission: '',
      n_process: '',
      sub_process: '',
      sign: '',
      title: '',
      type: '',
      title_photographer: '',
      type_photographer: '',
      formula: '',
      value_now: '',
      value_optimal: '',
      collection_reference: '',
      collaborative_devices: '',
      determining_missions_id: '',
      processes_id: '',
      sub_processes_id: '',
      id_route: this.$route['params']['id'],
      status_show: false,
      status_loading: false,
    }
  },
  methods: {
    acceptComplete(){
      if (this.status_loading){
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }

          })
          .catch();
    },
    store(){
      if (!this.sign.length){
        toast.error('نشانه مسئله اجباری است!')
        return
      }
      else if (! this.title.length){
        toast.error('عنوان مسئله اجباری است!')
        return;
      }else if (!this.type.length){
        toast.error('سطح مسئله اجباری است!')
        return;
      }else if (!this.title_photographer.length){
        toast.error('عنوان نماگر اجباری است!')
        return;
      }else if (!this.type_photographer.length){
        toast.error('نوع نماگر اجباری است!')
        return;
      }else if (!this.formula.length){
        toast.error('فرمول اجباری است!')
        return;
      }else if (!this.value_now .length){
        toast.error('مقدار کنونی اجباری است!')
        return;
      }else if (!this.value_optimal.length){
        toast.error('مقدار مطلوب اجباری است!')
        return;
      }else if (!this.collection_reference.length){
        toast.error('مرجع اخذ داده اجباری است!')
        return;
      }
      else if (!this.collaborative_devices.length){
        toast.error('دستگاه های تابعه همکار اجباری است!')
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('sign', this.sign)
      formdata.append('title', this.title)
      formdata.append('type', this.type)
      formdata.append('title_photographer', this.title_photographer)
      formdata.append('type_photographer', this.type_photographer)
      formdata.append('formula', this.formula)
      formdata.append('value_now', this.value_now)
      formdata.append('value_optimal', this.value_optimal)
      formdata.append('collection_reference', this.collection_reference)
      formdata.append('collaborative_devices', this.collaborative_devices)
      formdata.append('determining_missions_id', this.determining_missions_id)
      formdata.append('processes_id', this.processes_id)
      formdata.append('sub_processes_id', this.sub_processes_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
           this.resetData()
            this.all()
          })
          .catch();
    },
    all(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {
              this.allItems.push(item)

            })
          })
          .catch();
    },
    resetData() {
      this.sign = ''
      this.title = ''
      this.type = ''
      this.title_photographer = ''
      this.type_photographer = ''
      this.formula = ''
      this.value_now = ''
      this.value_optimal = ''
      this.collection_reference = ''
      this.collaborative_devices = ''
      this.determining_missions_id = ''
      this.processes_id = ''
      this.sub_processes_id = ''
    },
    setProcess() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/select/${this.Determining_Mission.id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.Process.length = 0
            this.Process = response.item
            this.n_process = response.item.processes.title
            this.sub_process = response.item.sub_processes.title
            this.processes_id = response.item.processes.id
            this.sub_processes_id = response.item.sub_processes.id
            this.determining_missions_id = response.item.id


          })
          .catch();
    },
    allItemsDetermining_Missions() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsDetermining_Mission.length = 0
            response.all.forEach((item) => {
              this.allItemsDetermining_Mission.push(item)

            })
          })
          .catch();
    },
    checkIsMother(){
      if (!this.is_mother){
        router.push('/')
      }

    }
  },
  mounted() {
    this.allItemsDetermining_Missions()
    this.all()
    this.checkIsMother()
  },
  watch: {
    Determining_Mission(newValue, oldValue) {
      this.setProcess()
    },
  }
}
</script>
<style scoped lang="scss">

</style>